import React, { useEffect, useState, useRef } from "react";
import { useCart } from "./Context/Createcontext";
import useSessionTimeout from "./hooks/useSessionTimeout";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

// ── Global toast (react-hot-toast) ───────────────────
import { Toaster } from "react-hot-toast";

import Navbar from "./Components/common/Navbar";
import SubNavbar from "./Components/common/Subnavbar";
import RequireAuth from "./Components/common/RequireAuth";
import Footer from "./Components/common/Footer";
import { CartProvider } from "./Context/Createcontext";
import { WishlistProvider } from "./Context/WishlistContext";

import HomePage from "./Pages/Home";
import LaunchingSoon from "./Pages/LaunchingSoon";
import ShopBrand from "./Pages/shopbrand";
import Categories from "./Pages/Categories";
import Featured from "./Pages/Featured";
import Cartpage from "./Pages/Cartpage";
import FAQ from "./Pages/Faq";
import About from "./Pages/About";
import Ordercancel from "./Pages/Ordercancel";
import Orderdetails from "./Pages/Orderdetails";
import CancellationModal from "./Pages/Cancelreason";
import Wishlist from "./Pages/Wishlist";
import BranchLocations from "./Pages/Branches";
import ProfilePage from "./Pages/Myprofile";
import ProductCard from "./Pages/Featureproduct";
import RootRedirect from "./Pages/RootRedirect";
import HeroFeatured from "./Pages/Herofeatured";
import Concerns from "./Pages/Concerns";
import Allbrands from "./Pages/Brandsall";
import ThankYou from "./Pages/Thankyou";
import WhatsAppIcon from "./Components/common/WhatsAppIcon";
import MyOrders from "./Pages/MyOrders";
import RootLoader from "./Components/common/RootLoader";
import MyTransactions from "./Pages/MyTransactions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import CancellationPolicy from "./Pages/CancellationPolicy";
import Manufacturerbrand from "./Pages/Manufacturerbrand";
import Allproducts from "./Pages/Allproducts";
import MyPrescription from "./Pages/MyPrescription.js";
import ContactPage from "./Pages/Contact";
import TermsAndConditions from "./Pages/Terms";
import BlogPage from "./Pages/Blogs.js";
import BlogDetails from "./Pages/BlogDetails.js";

// Admin
import ProductList from "./Admin/ProductList";
import PrescriptionList from "./Admin/PrescriptionList.jsx";
import AdminDashboard from "./Admin/AdminDashboard";
import EditProduct from "./Admin/EditProduct";
import ListOrder from "./Admin/ListOrder";
import UserProfile from "./Admin/UserProfile";
import ListVendor from "./Admin/ListVendor";
import AddVendor from "./Admin/AddVendors";
import EditVendor from "./Admin/EditVendors";
import ListCustomers from "./Admin/ListCoustomers";
import CustomerDetails from "./Admin/ViewDetailedCustomer";
import PageNotFound from "./Admin/PageNotFound";
import LoginScreen from "./Admin/Loginadmin";
import SubcategoryManagement from "./Admin/SubcategoryManagement";
import CategoryManagement from "./Admin/CategoryManagement";
import ProductApproval from "./Admin/AdminAction";
import VendorProductStatus from "./Admin/VendorProductStatus ";
import UploadProducts from "./Admin/BulkProduct";
import AddOn from "./Admin/AddOn";
import CouponManager from "./Admin/CouponManger";
import Adddata from "./Admin/Adddata";
import ManufacturerManagement from "./Admin/Manufacturer";
import Concenmanagement from "./Admin/Concern";
import AddProducts from "./Admin/Addproducts";
import Orderlist from "./Admin/Orderlist";
import OurBlogAdmin from "./Admin/OurBlogAdmin.jsx";
import BlogManagement from "./Admin/BlogsType.jsx";
import ManageStores from "./Admin/ManageStores.jsx";
import AddStore from "./Admin/AddStore.jsx";
import EditStore from "./Admin/EditStore.jsx";
import PaymentsList from "./Admin/Payments.jsx";
import CustomerQueries from "./Admin/CustomerQuerys.jsx";
import OrderTransferHistory from "./Admin/OrderTransferHistory.jsx";
import AccessControl from "./Admin/AccessControl.jsx";

import { Navigate } from "react-router-dom";
import { AppProvider } from "./Context/AppContext.js";

function App() {
  const [isSignedIn, setIsSignedIn] = useState(false);

  useEffect(() => {
    setIsSignedIn(localStorage.getItem("isSignedIn") === "true");
  }, []);

  const handleSignIn = () => {
    localStorage.setItem("isSignedIn", "true");
    setIsSignedIn(true);
  };

  const handleSignOut = () => {
    localStorage.setItem("isSignedIn", "false");
    setIsSignedIn(false);
  };

  const Layout = () => {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith("/ng-admin");
    const isRootPath = location.pathname === "/" || location.pathname.startsWith("/launch/");

    const isHomeRoute = location.pathname === "/home";
    const isFirstLoadRef = useRef(true);
    const [showRootLoader, setShowRootLoader] = useState(false);

    useEffect(() => {
      if (!isAdminRoute && isHomeRoute && isFirstLoadRef.current) {
        setShowRootLoader(true);
        const timer = setTimeout(() => setShowRootLoader(false), 1500);
        return () => clearTimeout(timer);
      }
      isFirstLoadRef.current = false;
    }, []);

    useEffect(() => {
      document.documentElement.classList.add("scrollbar-hide");
    }, []);
    const content = (
      <>
        {/*
          ── Global Toaster (react-hot-toast) ─────────────────────────────
          z-index: 999999 — MUST be higher than:
            • Popup modal    z-[9999]   = 9999
            • Sidebar drawer z-[10000]  = 10000
            • Navbar         z-[1000]   = 1000
          So we set containerStyle zIndex to 999999 to always float on top.
          react-hot-toast uses its own portal, so containerStyle targets
          the outer wrapper div that react-hot-toast injects into <body>.
        */}
        <Toaster
          position="bottom-right"
          reverseOrder={false}
          gutter={10}
          containerStyle={{ zIndex: 999999 }}
          toastOptions={{
            duration: 3000,
            style: {
              fontFamily: "Poppins, system-ui, sans-serif",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "12px",
              padding: "12px 16px",
              boxShadow: "0 8px 32px rgba(22,44,42,0.20)",
              maxWidth: "360px",
            },
            success: {
              style: {
                background: "#e8f8f1",
                color: "#1a7a4a",
                border: "1.5px solid #a3e6c5",
              },
              iconTheme: {
                primary: "#1a7a4a",
                secondary: "#e8f8f1",
              },
            },
            error: {
              style: {
                background: "#feecec",
                color: "#c0392b",
                border: "1.5px solid #f5b8b8",
              },
              iconTheme: {
                primary: "#c0392b",
                secondary: "#feecec",
              },
            },
            loading: {
              style: {
                background: "#eaf4f3",
                color: "#1e4a46",
                border: "1.5px solid #d4ecea",
              },
              iconTheme: {
                primary: "#1e4a46",
                secondary: "#eaf4f3",
              },
            },
            // Plain toast() calls (e.g. "please log in" nudges) — a neutral
            // informational look, distinct from the red error state.
            blank: {
              style: {
                background: "#eaf4f3",
                color: "#1e4a46",
                border: "1.5px solid #d4ecea",
              },
            },
          }}
        />

        {showRootLoader && !isAdminRoute && <RootLoader />}

        {!isAdminRoute && !isRootPath && <Navbar />}
        {!isAdminRoute && !isRootPath && <SubNavbar />}

        {/*
          mt breakdown (fixed navbar stack):
          Desktop: Ticker(28) + MainBar(72) + SubNavbar(52) = 152px
          Mobile:  Ticker(28) + Row1(58)   + Row2(52)      = 138px
        */}
        <div className={isAdminRoute ? "mt-0 flex-grow" : " flex-grow"}>
          <Routes>
            <Route path="/" element={<LaunchingSoon />} />
            <Route path="/launch/terms-and-conditions" element={<TermsAndConditions launchOnly />} />
            <Route path="/launch/privacy-policy" element={<PrivacyPolicy launchOnly />} />
            <Route path="/launch/*" element={<Navigate to="/" replace />} />
            <Route path="/home" element={<HomePage />} />

            <Route
              path="/ThankYou"
              element={
                <RequireAuth>
                  <ThankYou />
                </RequireAuth>
              }
            />
            <Route path="/shopbrand" element={<ShopBrand />} />
            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/blogs/:slug" element={<BlogDetails />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/featured-products" element={<Featured />} />
            <Route
              path="/cart"
              element={
                <RequireAuth>
                  <Cartpage />
                </RequireAuth>
              }
            />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about-us" element={<About />} />
            <Route
              path="/ordercancel"
              element={
                <RequireAuth>
                  <Ordercancel />
                </RequireAuth>
              }
            />
            <Route
              path="/orderdetails"
              element={
                <RequireAuth>
                  <Orderdetails />
                </RequireAuth>
              }
            />
            <Route
              path="/cancelreason"
              element={
                <RequireAuth>
                  <CancellationModal />
                </RequireAuth>
              }
            />
            <Route
              path="/wishlist"
              element={
                <RequireAuth>
                  <Wishlist />
                </RequireAuth>
              }
            />
            <Route path="/medical-stores" element={<BranchLocations />} />
            <Route
              path="/profilepage"
              element={
                <RequireAuth>
                  <ProfilePage />
                </RequireAuth>
              }
            />
            <Route path="/products/:product_id" element={<ProductCard />} />
            <Route path="/hero_url" element={<HeroFeatured />} />
            <Route path="/shop-by-concern/:name" element={<Concerns />} />
            <Route path="/shop-by-concern" element={<Concerns />} />
            <Route
              path="/my-prescriptions"
              element={
                <RequireAuth>
                  <MyPrescription />
                </RequireAuth>
              }
            />
            <Route
              path="/my-orders"
              element={
                <RequireAuth>
                  <MyOrders />
                </RequireAuth>
              }
            />
            <Route
              path="/shop-by-category/:category_id"
              element={<Categories />}
            />
            <Route
              path="/shop-by-brand/:manufacturer_id"
              element={<Allbrands />}
            />
            <Route
              path="/my-transactions"
              element={
                <RequireAuth>
                  <MyTransactions />
                </RequireAuth>
              }
            />
            <Route path="/products" element={<Allproducts />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/cancellation-policy"
              element={<CancellationPolicy />}
            />

            {/* Admin */}
            <Route path="/ng-admin/login" element={<LoginScreen />} />
            <Route
              path="/ng-admin/"
              element={
                localStorage.getItem("admin_token") ? (
                  <AdminDashboard />
                ) : (
                  <Navigate to="/ng-admin/login" replace />
                )
              }
            >
              <Route index element={<UserProfile />} />
              <Route path="product-list" element={<ProductList />} />
              <Route path="prescription-list" element={<PrescriptionList />} />
              <Route path="edit-product/:id" element={<EditProduct />} />
              <Route path="order-list" element={<ListOrder />} />
              <Route path="employee" element={<ListVendor />} />
              <Route path="add-employee" element={<AddVendor />} />
              <Route path="edit-emplyee/:id" element={<EditVendor />} />
              <Route path="cat" element={<CategoryManagement />} />
              <Route path="subcat" element={<SubcategoryManagement />} />
              <Route path="customers" element={<ListCustomers />} />
              <Route path="customers/:id" element={<CustomerDetails />} />
              <Route path="admin-action" element={<ProductApproval />} />
              <Route path="vendor-action" element={<VendorProductStatus />} />
              <Route path="Bulk-Product" element={<UploadProducts />} />
              <Route path="addon" element={<AddOn />} />
              <Route path="coupon" element={<CouponManager />} />
              <Route path="adddata" element={<Adddata />} />
              <Route path="manufacturer" element={<ManufacturerManagement />} />
              <Route path="concern" element={<Concenmanagement />} />
              <Route path="add-product" element={<AddProducts />} />
              <Route path="orders" element={<Orderlist />} />
              <Route path="branches" element={<ManageStores />} />
              <Route path="add-branch" element={<AddStore />} />
              <Route path="edit-branch/:id" element={<EditStore />} />
              <Route path="payments" element={<PaymentsList />} />
              <Route path="customer-queries" element={<CustomerQueries />} />
              <Route
                path="order-transfer-history"
                element={<OrderTransferHistory />}
              />
              <Route path="access-control" element={<AccessControl />} />
              <Route path="blogs" element={<OurBlogAdmin />} />
              <Route path="blog-types" element={<BlogManagement />} />
            </Route>

            <Route path="/*" element={<PageNotFound />} />
          </Routes>

          {!isAdminRoute && !isRootPath && <WhatsAppIcon />}
        </div>

        {!isAdminRoute && !isRootPath && <Footer />}
      </>
    );

    if (isAdminRoute) {
      const AdminLayout = () => {
        useSessionTimeout(30);
        return content;
      };
      return <AdminLayout />;
    }

    return (
      <AppProvider>
        <WishlistProvider>
          <CartProvider>
            <div className="App">{content}</div>
          </CartProvider>
        </WishlistProvider>
      </AppProvider>
    );
  };

  return (
    <Router>
      <div className="App">
        <Layout />
      </div>
    </Router>
  );
}

export default App;

